/*
    Defines what is required in the project parent controller:
    @name newReview
    @description Defines the page for the review disclaimer
    @requires $scope.details
    @requires $scope.isProfessional
*/
module.exports = function (bootstrap) {
    bootstrap.directive('reviewDisclaimer', function () {
        return {
            restrict: 'A',
            scope: false,
            replace: false,
            template: require('directives/reviews/reviewDisclaimer.html'),
            controller: ['$scope', '$state', 'coremetrics', function ($scope, $state, coremetrics) {

                $scope.decline = function () {
                    coremetrics.elementTag($scope.parentConfig.categoryId + ':WRITE A REVIEW ATTESTATION:DECLINE', $scope.parentConfig.categoryId + ':WRITE A REVIEW ATTESTATION');
                    $scope.backAction();
                };

                $scope.goToReview = function () {
                    coremetrics.elementTag($scope.parentConfig.categoryId + ':WRITE A REVIEW ATTESTATION:ACCEPT', $scope.parentConfig.categoryId + ':WRITE A REVIEW ATTESTATION');
                    $state.go('providers.newReview', {
                        details: $state.params.details || null,
                        displayName: $state.params.displayName,
                        signedDisclaimer: true,
                        practitionerId: $state.params.practitionerId,
                        vendorId : $state.params.vendorId,
                        locationSequenceNumber: $state.params.locationSequenceNumber,
                        productId: $state.params.productId
                    }, { reload: true });
                };

                $scope.$watch('reviews', function(newVal){
                   if(newVal){
                       $scope.limit = $scope.reviews.length;
                   }
                });
            }]
        };

    });
};